export default "__VITE_ASSET__11d7f5c7__"